module.exports = __webpack_public_path__ + "img/企业用户.ff77ee7c.png";